import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const PopupE = ({
  show,
  handleClose,
  title,
  label,
  placeholder,
  onChangeMessage,
  message,
  saveData,
  messageValidation,
  setMessageValidation,
}) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h5>{title}</h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="form-group">
            <label>
              {label}
              <span className="reqStar">*</span>
            </label>
            <textarea
              value={message}
              className={
                "form-control inputDec " +
                (messageValidation ? "border-validation" : "")
              }
              onFocus={() => setMessageValidation(false)}
              rows="5"
              placeholder={placeholder}
              onChange={(e) => onChangeMessage(e.target.value)}
            ></textarea>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <p
          className="text-primary btn mt-2 cursor-pointer"
          onClick={handleClose}
        >
          Cancel
        </p>
        <Button variant="primary" onClick={() => saveData()}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PopupE;
